// Ballarat suburbs served — each has unique copy for SEO.
// New suburbs added Feb 2026 per client request.

export const suburbs = [
  {
    slug: 'ballarat',
    name: 'Ballarat Central',
    postcode: '3350',
    location: 'central Ballarat',
    intro:
      "We service homes across the heart of Ballarat, from the tree-lined streets around the Botanic Gardens to the CBD's mix of period cottages and family homes. Our team understands the seasonal challenges Ballarat gardens face: cold, damp winters that encourage moss, hot dry summers that stress lawns, and clay-heavy soil that needs the right mowing height to stay healthy.",
    highlight: 'Central Ballarat lawn mowing, gardening and weed control.',
  },
  {
    slug: 'ballarat-north',
    name: 'Ballarat North',
    postcode: '3350',
    location: 'northern Ballarat',
    intro:
      'Ballarat North homes range from established heritage properties to newer family builds around Sovereign Hill and the northern suburbs. We take care of everything from small courtyard gardens to larger family lots, keeping lawns tidy year-round with careful mowing, edging, and clean-ups.',
    highlight: 'Ballarat North lawn care and garden maintenance.',
  },
  {
    slug: 'ballarat-east',
    name: 'Ballarat East',
    postcode: '3350',
    location: 'eastern Ballarat',
    intro:
      "Ballarat East is full of character homes with mature trees, cottage gardens, and traditional lawns that reward regular care. Our team keeps things looking sharp with reliable mowing schedules, thoughtful edging, and seasonal garden care that respects the suburb's heritage feel.",
    highlight: 'Ballarat East lawn care and garden tidy-ups for heritage homes.',
  },
  {
    slug: 'alfredton',
    name: 'Alfredton',
    postcode: '3350',
    location: 'western Ballarat',
    intro:
      "Alfredton is a family-friendly pocket of Ballarat with a real mix of block sizes, mature gardens, and open backyards. We look after weekly mows, seasonal tidy-ups, weed control, and garden care across the suburb.",
    highlight: 'Alfredton lawn mowing and gardening with dependable local service.',
  },
  {
    slug: 'ascot',
    name: 'Ascot',
    postcode: '3364',
    location: 'north-west of Ballarat',
    intro:
      'Ascot is a quiet rural pocket north-west of Ballarat where larger blocks and semi-acreage properties are common. We handle bigger mowing jobs, driveway edging, and general grounds care for country-style homes that need reliable, well-equipped crews.',
    highlight: 'Ascot acreage mowing and garden maintenance for rural Ballarat properties.',
  },
  {
    slug: 'bakery-hill',
    name: 'Bakery Hill',
    postcode: '3350',
    location: 'central Ballarat',
    intro:
      "Bakery Hill sits right next to Ballarat's CBD with a mix of small heritage cottages, unit blocks, and inner-city rentals. We're set up for tight-access properties, courtyard mows, and quick tidy-ups for landlords and busy owners.",
    highlight: 'Bakery Hill lawn mowing and courtyard garden care for inner-Ballarat homes.',
  },
  {
    slug: 'black-hill',
    name: 'Black Hill',
    postcode: '3350',
    location: 'north-eastern Ballarat',
    intro:
      'Black Hill homes often back onto bushland reserves, which means gardens need attentive weed control and regular tidy-ups to stay in check. We keep local properties tidy and manageable with regular scheduled visits.',
    highlight: 'Black Hill lawn mowing and weed control for homes near bushland reserves.',
  },
  {
    slug: 'blowhard',
    name: 'Blowhard',
    postcode: '3352',
    location: 'north-west of Ballarat',
    intro:
      "Blowhard is a rural locality north-west of Ballarat where larger properties, paddock edges, and long driveways are typical. We bring the right gear to handle acreage mowing, fence-line clean-ups, and seasonal weed control.",
    highlight: 'Blowhard rural lawn care, acreage mowing, and paddock-edge tidy-ups.',
  },
  {
    slug: 'bonshaw',
    name: 'Bonshaw',
    postcode: '3352',
    location: 'western Ballarat',
    intro:
      'Bonshaw is a small semi-rural community close to Ballarat proper, with homes ranging from tidy suburban blocks to larger properties on generous land. We keep lawns and gardens neat for busy families and older residents alike.',
    highlight: 'Bonshaw lawn mowing and garden maintenance for suburban and semi-rural blocks.',
  },
  {
    slug: 'brown-hill',
    name: 'Brown Hill',
    postcode: '3350',
    location: 'north-eastern Ballarat',
    intro:
      'Brown Hill blends older weatherboard homes with newer builds on generous blocks. From bushland edges to open family yards, we handle mowing, weed control, and general garden maintenance with local know-how.',
    highlight: 'Brown Hill garden maintenance and lawn mowing on larger family blocks.',
  },
  {
    slug: 'bungaree',
    name: 'Bungaree',
    postcode: '3352',
    location: 'east of Ballarat',
    intro:
      "Bungaree is a small township east of Ballarat with paddock-fringed homes and larger rural blocks. We're comfortable with acreage mowing, driveway edging, and general grounds care for country properties.",
    highlight: 'Bungaree acreage mowing and rural property maintenance near Ballarat.',
  },
  {
    slug: 'buninyong',
    name: 'Buninyong',
    postcode: '3357',
    location: 'southern Ballarat',
    intro:
      'Buninyong is a historic township south of Ballarat with heritage streetscapes, cottage gardens, and semi-rural properties on the fringes. Our team looks after weekly mows, garden bed weeding, and full seasonal tidy-ups across the area.',
    highlight: 'Buninyong lawn mowing and cottage garden maintenance for heritage properties.',
  },
  {
    slug: 'bunkers-hill',
    name: 'Bunkers Hill',
    postcode: '3352',
    location: 'north of Ballarat',
    intro:
      'Bunkers Hill is a quiet rural locality north of Ballarat where large blocks, established gum trees, and long grass lines are the norm. We handle acreage mowing, tree-line clean-ups, and green waste removal in one visit.',
    highlight: 'Bunkers Hill acreage mowing and green waste removal for rural properties.',
  },
  {
    slug: 'canadian',
    name: 'Canadian',
    postcode: '3350',
    location: 'south-eastern Ballarat',
    intro:
      "Canadian sits east of Ballarat's CBD with a good mix of family homes, older brick veneers, and newer builds. We provide regular mowing, weed control, and garden maintenance so residents can spend their weekends off the mower.",
    highlight: 'Canadian lawn mowing and family garden maintenance across the suburb.',
  },
  {
    slug: 'cardigan',
    name: 'Cardigan',
    postcode: '3352',
    location: 'west of Ballarat',
    intro:
      'Cardigan is a semi-rural pocket west of Ballarat with lifestyle properties and mid-sized blocks. Our crew is well-suited to bigger mows, driveway edging, and seasonal garden refreshes.',
    highlight: 'Cardigan lifestyle-property lawn care and garden maintenance near Ballarat.',
  },
  {
    slug: 'cardigan-village',
    name: 'Cardigan Village',
    postcode: '3352',
    location: 'west of Ballarat',
    intro:
      'Cardigan Village is a small township-style community with tidy family blocks and open lawns. We help residents stay on top of fast-growing spring grass and keep gardens tidy through summer.',
    highlight: 'Cardigan Village lawn mowing and garden maintenance for family homes.',
  },
  {
    slug: 'delacombe',
    name: 'Delacombe',
    postcode: '3356',
    location: 'south-western Ballarat',
    intro:
      "Delacombe combines new estates with quiet older streets, and gardens vary from small tidy lots to sprawling family blocks. We tailor our service to whatever the property needs, from regular mowing to full seasonal make-overs.",
    highlight: 'Delacombe lawn mowing, weed control, and gardening for homes of every size.',
  },
  {
    slug: 'enfield',
    name: 'Enfield',
    postcode: '3352',
    location: 'south of Ballarat',
    intro:
      'Enfield is a rural locality south of Ballarat with acreage properties, native bushland, and long fence-lines. Our team is set up for larger mows, weed control across driveways and paths, and general grounds care around country homes.',
    highlight: 'Enfield acreage mowing, weed control, and rural property maintenance.',
  },
  {
    slug: 'eureka',
    name: 'Eureka',
    postcode: '3350',
    location: 'central-eastern Ballarat',
    intro:
      "Eureka carries strong local history and a leafy, established feel. Cottage yards and heritage gardens need careful mowing and edging, and that's exactly what our crew delivers on every visit.",
    highlight: 'Eureka lawn mowing and heritage garden care for character homes.',
  },
  {
    slug: 'golden-point',
    name: 'Golden Point',
    postcode: '3350',
    location: 'central-eastern Ballarat',
    intro:
      "Golden Point's rich gold-rush history is matched by classic cottages and leafy gardens that need careful care. We look after everything from tight courtyard mows to full seasonal garden tidy-ups across the suburb.",
    highlight: 'Golden Point lawn mowing and gardening for character homes and cottage yards.',
  },
  {
    slug: 'gong-gong',
    name: 'Gong Gong',
    postcode: '3352',
    location: 'north-east of Ballarat',
    intro:
      'Gong Gong is a quiet rural pocket north-east of Ballarat with acreage blocks, water reserves, and native trees. We handle larger mowing jobs, driveway edging, and green waste removal for country properties.',
    highlight: 'Gong Gong acreage mowing and garden maintenance for rural blocks.',
  },
  {
    slug: 'haddon',
    name: 'Haddon',
    postcode: '3351',
    location: 'south-west of Ballarat',
    intro:
      "Haddon is a semi-rural community south-west of Ballarat known for its larger blocks and mix of newer family homes and long-term country properties. Our team is well-equipped for bigger lawns, paddock trims, and weed control across gravel and paths.",
    highlight: 'Haddon acreage mowing, weed control, and rural garden care.',
  },
  {
    slug: 'invermay',
    name: 'Invermay',
    postcode: '3352',
    location: 'north of Ballarat',
    intro:
      "Invermay is a rural locality north of Ballarat with lifestyle blocks and established country gardens. Whether it's a long fence-line, a big front lawn, or a paddock edge, our crew shows up prepared to handle it.",
    highlight: 'Invermay lifestyle-block mowing and country garden maintenance.',
  },
  {
    slug: 'invermay-park',
    name: 'Invermay Park',
    postcode: '3350',
    location: 'northern Ballarat',
    intro:
      "Invermay Park blends suburban family blocks with quieter park-adjacent streets. We look after regular mowing, garden bed weeding, and seasonal tidy-ups so properties always look inviting from the street.",
    highlight: 'Invermay Park lawn mowing and garden care for family homes.',
  },
  {
    slug: 'lake-gardens',
    name: 'Lake Gardens',
    postcode: '3355',
    location: 'western Ballarat',
    intro:
      'Lake Gardens sits close to Lake Wendouree and combines quiet streetscapes with established gardens. We help residents keep their nature-strip lawns crisp and back gardens tidy through every Ballarat season.',
    highlight: 'Lake Gardens lawn mowing and garden maintenance near Lake Wendouree.',
  },
  {
    slug: 'lake-wendouree',
    name: 'Lake Wendouree',
    postcode: '3350',
    location: 'western Ballarat',
    intro:
      "Lake Wendouree is one of Ballarat's most established suburbs, with mature street trees, formal gardens, and heritage homes. Our team provides the attention-to-detail these gardens deserve, with precise mowing, careful edging, and neat borders.",
    highlight: 'Lake Wendouree premium lawn care and heritage garden maintenance.',
  },
  {
    slug: 'learmonth',
    name: 'Learmonth',
    postcode: '3352',
    location: 'north of Ballarat',
    intro:
      "Learmonth is a small township north of Ballarat near Lake Learmonth, with country homes, larger blocks, and a genuine rural feel. We're set up for acreage mowing, weed control, and seasonal tidy-ups across the district.",
    highlight: 'Learmonth acreage mowing and rural garden maintenance near Lake Learmonth.',
  },
  {
    slug: 'lucas',
    name: 'Lucas',
    postcode: '3350',
    location: 'western Ballarat',
    intro:
      "Lucas is one of Ballarat's fastest growing suburbs, and new estates come with modern gardens that need consistent care from day one. We help Lucas homeowners get on top of freshly laid lawns and garden beds so the whole property matures beautifully.",
    highlight: 'Lawn mowing and garden care in Lucas, reliable service for newer estate homes.',
  },
  {
    slug: 'magpie',
    name: 'Magpie',
    postcode: '3352',
    location: 'southern Ballarat',
    intro:
      "Magpie is a quiet residential pocket south of Ballarat with a mix of long-standing family homes and neat blocks. We provide the reliable, no-fuss mowing and garden care that keeps properties looking their best.",
    highlight: 'Magpie lawn mowing and garden maintenance for family homes.',
  },
  {
    slug: 'miners-rest',
    name: 'Miners Rest',
    postcode: '3352',
    location: 'north-west of Ballarat',
    intro:
      "Miners Rest is a growing community north-west of Ballarat with new estates, semi-rural blocks, and everything in between. Our crew handles freshly laid lawns, garden beds, and full seasonal tidy-ups with equal care.",
    highlight: 'Miners Rest lawn mowing and estate garden maintenance for growing families.',
  },
  {
    slug: 'mitchell-park',
    name: 'Mitchell Park',
    postcode: '3355',
    location: 'western Ballarat',
    intro:
      'Mitchell Park sits between Lake Wendouree and the western estates, with a mix of established homes and newer builds. We keep lawns edged and garden beds weeded through every season.',
    highlight: 'Mitchell Park lawn care and garden maintenance in western Ballarat.',
  },
  {
    slug: 'mount-clear',
    name: 'Mount Clear',
    postcode: '3350',
    location: 'southern Ballarat',
    intro:
      "Mount Clear is a leafy, hilly southern Ballarat suburb with sloped lawns, bushland edges, and heritage homes. Our team is comfortable working across uneven blocks, keeping mowing tidy and edges crisp.",
    highlight: 'Mount Clear lawn mowing and garden care for hillside and heritage blocks.',
  },
  {
    slug: 'mount-helen',
    name: 'Mount Helen',
    postcode: '3350',
    location: 'southern Ballarat',
    intro:
      "Mount Helen is a leafy suburb close to Federation University with a mix of student rentals and long-term family homes. Our team is ideal for landlords, property managers, and busy residents who want reliable garden care without the hassle.",
    highlight: 'Mount Helen lawn mowing and garden care for landlords, rentals, and busy owners.',
  },
  {
    slug: 'mount-pleasant',
    name: 'Mount Pleasant',
    postcode: '3350',
    location: 'central-eastern Ballarat',
    intro:
      "Mount Pleasant is close to Ballarat's CBD and packed with classic weatherboard cottages, mature gardens, and tree-lined streets. We keep the lawns crisp, edges sharp, and garden beds tidy so homes look their best year-round.",
    highlight: 'Mount Pleasant lawn mowing and heritage garden care near central Ballarat.',
  },
  {
    slug: 'mount-rowan',
    name: 'Mount Rowan',
    postcode: '3352',
    location: 'northern Ballarat',
    intro:
      'Mount Rowan is a semi-rural locality north of Ballarat with lifestyle blocks, native paddocks, and long driveways. Our crew handles acreage mowing, fence-line clean-ups, and general grounds care across the area.',
    highlight: 'Mount Rowan acreage mowing and lifestyle-block garden maintenance.',
  },
  {
    slug: 'napoleons',
    name: 'Napoleons',
    postcode: '3352',
    location: 'south of Ballarat',
    intro:
      "Napoleons is a small rural community south of Ballarat with acreage blocks and country-style homes. We handle bigger mowing jobs, driveway edging, and seasonal tidy-ups for property owners who want the grounds looking their best.",
    highlight: 'Napoleons acreage mowing and country garden maintenance.',
  },
  {
    slug: 'nerrina',
    name: 'Nerrina',
    postcode: '3350',
    location: 'north-eastern Ballarat',
    intro:
      'Nerrina is a leafy suburb north-east of the Ballarat CBD with a mix of established homes and newer builds on generous blocks. Our team keeps lawns tidy and garden beds clear through every season.',
    highlight: 'Nerrina lawn mowing and garden maintenance for family blocks and newer builds.',
  },
  {
    slug: 'newington',
    name: 'Newington',
    postcode: '3350',
    location: 'central-western Ballarat',
    intro:
      "Newington sits just west of Lake Wendouree and features grand heritage homes, mature street trees, and traditional gardens. We provide the careful, detail-focused mowing and edging these established properties call for.",
    highlight: 'Newington premium lawn care and heritage garden maintenance.',
  },
  {
    slug: 'redan',
    name: 'Redan',
    postcode: '3350',
    location: 'southern Ballarat',
    intro:
      "Redan is a well-established Ballarat suburb with mature street trees and traditional yards. We provide steady, reliable mowing and garden care so residents can enjoy their property without spending every weekend on the tools.",
    highlight: 'Redan lawn mowing and garden care with reliable weekly schedules.',
  },
  {
    slug: 'ross-creek',
    name: 'Ross Creek',
    postcode: '3351',
    location: 'south-west of Ballarat',
    intro:
      'Ross Creek is a rural locality south-west of Ballarat with acreage properties, native bushland, and paddock edges. Our team is well-suited to bigger mowing jobs, weed control, and seasonal tidy-ups on country homes.',
    highlight: 'Ross Creek acreage mowing, weed control, and rural garden care.',
  },
  {
    slug: 'scotchmans-lead',
    name: 'Scotchmans Lead',
    postcode: '3352',
    location: 'south of Ballarat',
    intro:
      "Scotchmans Lead is a quiet semi-rural pocket south of Ballarat with lifestyle blocks and country homes. We handle bigger lawns, garden care, and general grounds care with local know-how.",
    highlight: 'Scotchmans Lead lawn mowing and rural garden maintenance.',
  },
  {
    slug: 'scotsburn',
    name: 'Scotsburn',
    postcode: '3352',
    location: 'south-east of Ballarat',
    intro:
      "Scotsburn is a small rural community south-east of Ballarat with larger blocks, established gum trees, and long grass lines. Our crew brings the right gear for acreage mowing and green waste removal in one visit.",
    highlight: 'Scotsburn acreage mowing and green waste removal for rural properties.',
  },
  {
    slug: 'sebastopol',
    name: 'Sebastopol',
    postcode: '3356',
    location: 'southern Ballarat',
    intro:
      'Sebastopol is a busy southern Ballarat suburb with a strong community feel and plenty of family homes. Our team helps residents stay ahead of fast-growing spring lawns and weedy beds with consistent, no-fuss maintenance.',
    highlight: 'Sebastopol lawn mowing, garden care, and weed control for busy households.',
  },
  {
    slug: 'smythes-creek',
    name: 'Smythes Creek',
    postcode: '3351',
    location: 'south-western Ballarat',
    intro:
      'Smythes Creek sits between Delacombe and the western rural fringe, with a good mix of family blocks and semi-rural properties. We handle regular mowing, weed control, and general garden care across the suburb.',
    highlight: 'Smythes Creek lawn mowing and garden maintenance for family and rural blocks.',
  },
  {
    slug: 'soldiers-hill',
    name: 'Soldiers Hill',
    postcode: '3350',
    location: 'central-northern Ballarat',
    intro:
      "Soldiers Hill is one of Ballarat's most photogenic inner suburbs, packed with heritage weatherboards, mature street trees, and cottage gardens. Our team provides the careful mowing and edging these character homes deserve.",
    highlight: 'Soldiers Hill lawn mowing and cottage garden maintenance for heritage homes.',
  },
  {
    slug: 'springbank',
    name: 'Springbank',
    postcode: '3352',
    location: 'south of Ballarat',
    intro:
      "Springbank is a rural pocket south of Ballarat where larger properties and long driveways are common. We handle acreage mowing, driveway edging, and general grounds care for country homes.",
    highlight: 'Springbank acreage mowing and rural garden maintenance.',
  },
  {
    slug: 'sulky',
    name: 'Sulky',
    postcode: '3352',
    location: 'north of Ballarat',
    intro:
      "Sulky is a small rural locality north of Ballarat with acreage blocks and country homes. Our team is comfortable with bigger mowing jobs, garden bed weeding, and fence-line clean-ups.",
    highlight: 'Sulky acreage mowing and rural garden care.',
  },
  {
    slug: 'wallace',
    name: 'Wallace',
    postcode: '3352',
    location: 'east of Ballarat',
    intro:
      'Wallace is a small township east of Ballarat with a mix of country homes and paddock-fringed blocks. Our crew handles acreage mowing, seasonal tidy-ups, and general grounds care for rural properties.',
    highlight: 'Wallace acreage mowing and rural property maintenance.',
  },
  {
    slug: 'warrenheip',
    name: 'Warrenheip',
    postcode: '3352',
    location: 'east of Ballarat',
    intro:
      "Warrenheip is a semi-rural locality east of Ballarat with lifestyle blocks, native trees, and larger family homes. We're set up for bigger mows, weed control across gravel and paths, and general grounds care around country properties.",
    highlight: 'Warrenheip lifestyle-block mowing and country garden maintenance.',
  },
  {
    slug: 'wattle-flat',
    name: 'Wattle Flat',
    postcode: '3352',
    location: 'north of Ballarat',
    intro:
      "Wattle Flat is a historic gold-rush township north of Ballarat with country homes, larger blocks, and mature gardens. Our team handles acreage mowing, garden bed weeding, and seasonal tidy-ups across the district.",
    highlight: 'Wattle Flat acreage mowing and rural garden maintenance.',
  },
  {
    slug: 'wendouree',
    name: 'Wendouree',
    postcode: '3355',
    location: 'western Ballarat',
    intro:
      'Wendouree is a busy western Ballarat suburb with family blocks, unit developments, and quiet cul-de-sacs. Our team keeps lawns tidy and garden beds clear for residents who want reliable service.',
    highlight: 'Wendouree lawn mowing and garden maintenance for family homes and units.',
  },
  {
    slug: 'windermere',
    name: 'Windermere',
    postcode: '3352',
    location: 'north of Ballarat',
    intro:
      "Windermere is a small rural community north of Ballarat with acreage blocks and country homes. We're well-suited to larger mowing jobs, driveway edging, and seasonal tidy-ups across the area.",
    highlight: 'Windermere acreage mowing and country garden care.',
  },
  {
    slug: 'winter-valley',
    name: 'Winter Valley',
    postcode: '3358',
    location: 'western Ballarat',
    intro:
      "Winter Valley's newer estates mean plenty of young gardens and lawns finding their feet. Our crew helps residents keep freshly laid turf healthy, edges sharp, and garden beds free of weeds, setting the property up for years of easy maintenance.",
    highlight: 'Winter Valley lawn and garden maintenance for growing families and new estates.',
  },
];

export const suburbBySlug = (slug) => suburbs.find((s) => s.slug === slug);
